/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Email_Auth_DescriptionInputs */

const en_admin_settings_groups_email_auth_description = /** @type {(inputs: Admin_Settings_Groups_Email_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email/password authentication`)
};

const zh_admin_settings_groups_email_auth_description = /** @type {(inputs: Admin_Settings_Groups_Email_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱/密码登录`)
};

/**
* | output |
* | --- |
* | "Email/password authentication" |
*
* @param {Admin_Settings_Groups_Email_Auth_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_email_auth_description = /** @type {((inputs?: Admin_Settings_Groups_Email_Auth_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Email_Auth_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_email_auth_description(inputs)
	return zh_admin_settings_groups_email_auth_description(inputs)
});
export { admin_settings_groups_email_auth_description as "admin.settings.groups.email_auth.description" }